import { MapUtils } from '../../utility/map-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../dto/dto.js';

export class ReviewStatistics extends DataModel {
  static readonly TYPE_ID: string = '4d37507426074736921d552a85c871fc';

  constructor(
    public readonly totalScore: number,
    public readonly numberOfRatings: number,
  ) {
    super();
  }

  get $typeId(): string {
    return ReviewStatistics.TYPE_ID;
  }

  get averageRating(): number {
    return this.numberOfRatings > 0 ? this.totalScore / this.numberOfRatings : 0;
  }

  static none(): ReviewStatistics {
    return new ReviewStatistics(0, 0);
  }

  add(score: number): ReviewStatistics {
    return new ReviewStatistics(this.totalScore + score, this.numberOfRatings + 1);
  }

  static fromMap(context: SerializationContext, map: SerializedData): ReviewStatistics {
    return new ReviewStatistics(
        MapUtils.get<number>(map, 'totalScore'),
        MapUtils.get<number>(map, 'numberOfRatings'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'totalScore': this.totalScore,
      'numberOfRatings': this.numberOfRatings,
    };
  }

  clone(): this {
    return new ReviewStatistics(
        this.totalScore,
        this.numberOfRatings,
    ) as this;
  }

  isSame(other: ReviewStatistics): boolean {
    if(other === this) {
      return true;
    }

    return other.totalScore === this.totalScore &&
      other.numberOfRatings === this.numberOfRatings;
  }
}

export class ReviewStatisticsBuilder extends DataModelBuilder<ReviewStatistics> {
  build(context: SerializationContext, map: SerializedData): ReviewStatistics {
    return ReviewStatistics.fromMap(context, map);
  }
}
